export function decimalPlaces(id) {
  $(`#${id}`).on("keyup", function (e) {
    let value = e.target.value;
    const cp = value.indexOf(".");
    if (cp > 0) {
      $(`#${id}`).val(value.slice(0, cp + 2));
    }
  });
}

export function integerValidation(id) {
  $(`#${id}`).on("change", function (e) {
    const value = e.target.value;
    if (Number.isInteger(Number(value))) {
      $(`#${id}`).val(Number.parseFloat(value).toFixed(1));
    }
  });
}

export function inputValidate(value, min, max, wrapper) {
  const fraction = value.split(".")[1] || 0;
  if (isNaN(parseFloat(value))) {
    $(`#${wrapper}-wrapper`).addClass("invalid");
    return false;
  } else {
    if (value < min || value > max || fraction.length > 1) {
      $(`#${wrapper}-wrapper`).addClass("invalid");
      return false;
    } else {
      $(`#${wrapper}-wrapper`).removeClass("invalid");
      return true;
    }
  }
}
